/* ============
 * Organizations Mutations
 * ============
 *
 * The mutations available for the organizations module.
 */

export const ALL = 'ALL';
export const SET_ALL = 'SET_ALL';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_ACTIVE_DOMAIN = 'SET_ACTIVE_DOMAIN';
export const RESET_ACTIVE_DOMAIN = 'RESET_ACTIVE_DOMAIN';

export default {
  SET_ALL,
  SET_CURRENT_PAGE,
  SET_ACTIVE_DOMAIN,
  RESET_ACTIVE_DOMAIN,
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/mutation-types.js